export default "__VITE_ASSET__wW6MXPlv__"